import { profileWidgetEdited } from '@wix/bi-logger-members-app-uou/v2';

import type { RootState } from '../store/root-reducer';
import type {
  MetaData,
  Nullable,
  PartialUpdatableFields,
  ThunkExtra,
} from '../types';

export const getCommonBIEventsData = (
  { controllerConfig }: ThunkExtra['flowAPI'],
  { site, users }: RootState,
  metaData: Nullable<MetaData>,
) => ({
  app_id: controllerConfig.appParams.appDefinitionId,
  biToken: metaData?.biToken ?? '',
  instance_id: controllerConfig.appParams.instanceId,
  is_social: !!site.isSocial,
  role: users.viewed.roles[0] ?? '',
  _: new Date().getTime(),
});

const isUndefined = <T>(value: T | undefined) => value === undefined;

export const emitProfileEditedBIEvent = (
  state: RootState,
  updatedFields: PartialUpdatableFields,
  { flowAPI, biLogger, metaData }: ThunkExtra,
) =>
  biLogger?.report(
    profileWidgetEdited({
      ...getCommonBIEventsData(flowAPI, state, metaData),
      name_changed: !!updatedFields.name,
      photo_changed: !!updatedFields.picture,
      cover_photo_change: !!updatedFields.cover,
      titleChanged: isUndefined(updatedFields.title),
    }),
  );
